import { createContext, useContext, useEffect, useState, useCallback } from "react";
import translations from "@/i18n";

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "it";
    return localStorage.getItem("afb_lang") || "it";
  });

  useEffect(() => {
    localStorage.setItem("afb_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback(
    (path) => {
      const parts = path.split(".");
      let node = translations[lang];
      for (const p of parts) {
        if (node && typeof node === "object" && p in node) node = node[p];
        else return path;
      }
      return node;
    },
    [lang]
  );

  const value = {
    lang,
    setLang,
    toggle: () => setLang((l) => (l === "it" ? "en" : "it")),
    t,
    pick: (item, key) => item?.[`${key}_${lang}`] ?? item?.[`${key}_it`] ?? "",
  };

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used within LangProvider");
  return ctx;
};
